import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { notify } from "../../../utils/shared";
import { getUsers } from "../user/_userAction";
const API_URL = process.env.REACT_APP_API_URL;

const FREE_SUBSCRIPTION = `${API_URL}/subscrption/createFreeSubscription`;
const GET_ALL_MEMBER_SUBSCRIPTIONS = `${API_URL}/player-subscriptions/getAllPlayerSubscriptions`;
const MEMBER_SUBSCRIPTION_URL = `${API_URL}/player-subscriptions`;
const GET_ALL_AGENT_SUBSCRIPTIONS = `${API_URL}/agent-subscriptions/getAllAgentSubscriptions`;
const AGENT_SUBSCRIPTION_URL = `${API_URL}/agent-subscriptions`;
const GET_ALL_CLUB_SUBSCRIPTIONS = `${API_URL}/club-subscriptions/getAllClubSubscriptions`;
const CLUB_SUBSCRIPTION_URL = `${API_URL}/club-subscriptions`;
const GET_ALL_SCOUT_SUBSCRIPTIONS = `${API_URL}/scout-subscriptions/getAllScoutSubscriptions`;
const SCOUT_SUBSCRIPTION_URL = `${API_URL}/scout-subscriptions`;


export const createFreeSubscription = createAsyncThunk(
  "createFreeSubscription",
  async ({values, page}: any, { rejectWithValue, dispatch }) => {
    try {
      console.log(values,">>> values >>>")
      const { data } = await axios.post(`${FREE_SUBSCRIPTION}`, values);
      console.log(FREE_SUBSCRIPTION,">>>> free subscription", values)
      notify(data.responseMessage, 'success');
      dispatch(getUsers({ page: page || 1, limit: 10 }))
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

// player subscription
export const getMemberSubscriptions = createAsyncThunk(
  "getMemberSubscriptions",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { page, limit, search = '' } = values;
      const { data } = await axios.get(`${GET_ALL_MEMBER_SUBSCRIPTIONS}?page=${page}&limit=${limit}&search=${search}`, {});
      return data;
    } catch (error: any) {
      const { responseMessage } = error?.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const updateMemberSubscriptionDetails = createAsyncThunk(
  "updateMemberSubscriptionDetails",
  async ({values, id, page}: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.put(`${MEMBER_SUBSCRIPTION_URL}/${id}`, values);
      notify(data.responseMessage, 'success');
      dispatch(getMemberSubscriptions({page: page || 1, limit:10}));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const addMemberSubscriptionDetails = createAsyncThunk(
  "addMemberSubscriptionDetails",
  async ({values,page}: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.post(`${MEMBER_SUBSCRIPTION_URL}`, values);
      notify(data.responseMessage, 'success');
      dispatch(getMemberSubscriptions({ page: page || 1, limit: 10 }))
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const deleteMemberSubscription = createAsyncThunk(
  "deleteMemberSubscription",
  async (values: any, { rejectWithValue, dispatch }) => { 
    try {
      const { data } = await axios.delete(`${MEMBER_SUBSCRIPTION_URL}/${values.id}`);
      notify(data.responseMessage, 'success'); 
      dispatch(getMemberSubscriptions({page: values.selectedPage || 1, limit:10}));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

// agent subscription
export const getAgentSubscriptions = createAsyncThunk(
  "getAgentSubscriptions",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { page, limit, search = '' } = values;
      const { data } = await axios.get(`${GET_ALL_AGENT_SUBSCRIPTIONS}?page=${page}&limit=${limit}&search=${search}`, {});
      return data;
    } catch (error: any) {
      const { responseMessage } = error?.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const updateAgentSubscriptionDetails = createAsyncThunk(
  "updateAgentSubscriptionDetails",
  async ({values, id, page}: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.put(`${AGENT_SUBSCRIPTION_URL}/${id}`, values);
      notify(data.responseMessage, 'success');
      dispatch(getAgentSubscriptions({page: page || 1, limit:10}));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const addAgentSubscriptionDetails = createAsyncThunk(
  "addAgentSubscriptionDetails",
  async ({values, page}: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.post(`${AGENT_SUBSCRIPTION_URL}`, values);
      notify(data.responseMessage, 'success');
      dispatch(getAgentSubscriptions({ page: page || 1, limit: 10 }));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const deleteAgentSubscription = createAsyncThunk(
  "deleteAgentSubscription",
  async (values: any, { rejectWithValue, dispatch }) => { 
    try {
      const { data } = await axios.delete(`${AGENT_SUBSCRIPTION_URL}/${values.id}`);
      notify(data.responseMessage, 'success'); 
      dispatch(getAgentSubscriptions({page: values.selectedPage || 1, limit:10}));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

// Club subscription
export const getClubSubscriptions = createAsyncThunk(
  "getClubSubscriptions",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { page, limit, search = '' } = values;
      const { data } = await axios.get(`${GET_ALL_CLUB_SUBSCRIPTIONS}?page=${page}&limit=${limit}&search=${search}`, {});
      return data;
    } catch (error: any) {
      const { responseMessage } = error?.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const updateClubSubscriptionDetails = createAsyncThunk(
  "updateClubSubscriptionDetails",
  async ({values, id, page}: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.put(`${CLUB_SUBSCRIPTION_URL}/${id}`, values);
      notify(data.responseMessage, 'success');
      dispatch(getClubSubscriptions({page: page || 1, limit:10}));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const addClubSubscriptionDetails = createAsyncThunk(
  "addClubSubscriptionDetails",
  async ({values, page}: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.post(`${CLUB_SUBSCRIPTION_URL}`, values);
      notify(data.responseMessage, 'success');
      dispatch(getClubSubscriptions({ page: page || 1, limit: 10 }));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const deleteClubSubscription = createAsyncThunk(
  "deleteClubSubscription",
  async (values: any, { rejectWithValue, dispatch }) => { 
    try {
      const { data } = await axios.delete(`${CLUB_SUBSCRIPTION_URL}/${values.id}`);
      notify(data.responseMessage, 'success'); 
      dispatch(getClubSubscriptions({page: values.selectedPage || 1, limit:10}));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);


// Scout subscription
export const getScoutSubscriptions = createAsyncThunk(
  "getScoutSubscriptions",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { page, limit, search = '' } = values;
      const { data } = await axios.get(`${GET_ALL_SCOUT_SUBSCRIPTIONS}?page=${page}&limit=${limit}&search=${search}`, {});
      return data;
    } catch (error: any) {
      const { responseMessage } = error?.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const updateScoutSubscriptionDetails = createAsyncThunk(
  "updateScoutSubscriptionDetails",
  async ({values, id, page}: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.put(`${SCOUT_SUBSCRIPTION_URL}/${id}`, values);
      notify(data.responseMessage, 'success');
      dispatch(getScoutSubscriptions({page: page || 1, limit:10}));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const addScoutSubscriptionDetails = createAsyncThunk(
  "addScoutSubscriptionDetails",
  async ({values, page}: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.post(`${SCOUT_SUBSCRIPTION_URL}`, values);
      notify(data.responseMessage, 'success');
      dispatch(getScoutSubscriptions({ page: page || 1, limit: 10 }));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const deleteScoutSubscription = createAsyncThunk(
  "deleteScoutSubscription",
  async (values: any, { rejectWithValue, dispatch }) => { 
    try {
      const { data } = await axios.delete(`${SCOUT_SUBSCRIPTION_URL}/${values.id}`);
      notify(data.responseMessage, 'success'); 
      dispatch(getScoutSubscriptions({page: values.selectedPage || 1, limit:10}));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

